import {Component, Input} from "@angular/core";
import {OnfidoVerificationStatus} from "../../api/entity/identity-verification";

@Component({
    selector: 'tfl-bo-onfido-status-badge',
    template: `
        <ng-container [ngSwitch]="status">
            <span *ngSwitchCase="'VERIFIED'" class="label label-success">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.VERIFIED' | translate }}
            </span>
            <span *ngSwitchCase="'DECLINED'" class="label label-danger">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.DECLINED' | translate }}
            </span>
            <span *ngSwitchCase="'OPEN_TO_UPLOAD_DATA'" class="label label-default">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.OPEN_TO_UPLOAD_DATA' | translate }}
            </span>
            <span *ngSwitchCase="'IN_PROGRESS'" class="label label-info">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.IN_PROGRESS' | translate }}
            </span>
            <span *ngSwitchCase="'INVALID'" class="label label-warning">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.INVALID' | translate }}
            </span>
            <span *ngSwitchCase="'CONSIDER'" class="label label-warning">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.CONSIDER' | translate }}
            </span>
            <span *ngSwitchCase="'OUT_OF_VERIFICATION'" class="label label-default">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.OUT_OF_VERIFICATION' | translate }}
            </span>
        </ng-container>
    `
})
export class OnfidoStatusBadgeComponent {

    @Input() status: OnfidoVerificationStatus;
    @Input() explanation: string = null;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/onfido/onfido.status-badge.component.ts